
import type { IMassGridCapacitiesDto } from "types/capacity";
import type { ILoadCapacityDto } from "types/load-capacity";
import Fetch from "utils/fetch";

export const saveLoadCapacityAsync = async (request: ILoadCapacityDto[]) => {
  return await Fetch.post(`/load-capacities/create-load-capacity`, request);
};

export const GetLoadByBusinessUnitAndSupplierAsync = (
  dateFrom?: string,
  dateTo?: string,
  businessUnitId?: number,
  supplierId?: number
) =>
  Fetch.get(
    `/load-capacities/by-businessunit-supplier?businessUnitId=${businessUnitId}&supplierId=${supplierId}&dateFrom=${dateFrom}&dateTo=${dateTo}`
  ).then(({ data }) => data);

export const SaveLoadCapacitiesInMass = (body: IMassGridCapacitiesDto) =>
  Fetch.post("/load-capacities/create-mass-load-capacities", body);
